import React, { useState } from "react";

const AddServiceProvider = ({
  taxpayerActivities,
  taxpayerSearch,
  onAddServiceProvider,
  onTaxpayerSearchChange,
  handleCancel,
  handleAddSuccess,
  loading,
}) => {
  const [selectedActivity, setSelectedActivity] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [localTaxNumber, setLocalTaxNumber] = useState("");

  const handleTaxNumberChange = (e) => {
    const value = e.target.value;
    setLocalTaxNumber(value);
    setSelectedActivity("");
    setError("");
    setSuccess("");
  };

  const handleSearchTaxpayer = () => {
    if (!localTaxNumber) {
      setError("Please enter a tax number");
      return;
    }
    onTaxpayerSearchChange(localTaxNumber);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchTaxpayer();
    }
  };

  const handleActivitySelect = (e) => {
    setSelectedActivity(e.target.value);
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!taxpayerSearch) {
      setError("Please search for a taxpayer first");
      return;
    }

    if (!selectedActivity) {
      setError("Please select an activity");
      return;
    }

    const selectedActivityData = taxpayerActivities.find(
      (activity) => activity.activity === selectedActivity
    );

    if (!selectedActivityData) {
      setError("Selected activity not found");
      return;
    }

    const providerData = {
      name: selectedActivityData.description,
      taxNumber: taxpayerSearch,
      activity: selectedActivity,
      canBeDeleted: true,
    };

    onAddServiceProvider(providerData);

    // Reset form
    onTaxpayerSearchChange("");
    setLocalTaxNumber("");
    setSelectedActivity("");
    // setError("");
    // setSuccess("Service provider added successfully!");

    // Auto hide success message and form after 2 seconds
    setTimeout(() => {
      setSuccess("");
      handleAddSuccess();
    }, 2000);
  };

  const handleReset = () => {
    onTaxpayerSearchChange("");
    setLocalTaxNumber("");
    setSelectedActivity("");
    setError("");
    setSuccess("");
  };

  return (
    <div className="card">
      <h3>Add New Service Provider</h3>

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="taxNumber">Tax Number:</label>
          <div className="d-flex gap-2 align-items-center">
            <input
              type="text"
              id="taxNumber"
              value={localTaxNumber}
              onChange={handleTaxNumberChange}
              onKeyPress={handleKeyPress}
              placeholder="Enter taxpayer tax number"
              disabled={loading.fetchingActivities || loading.addingProvider}
              className="form-control tax-number-input"
              style={{ maxWidth: "300px" }}
            />
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleSearchTaxpayer}
              disabled={!localTaxNumber || loading.fetchingActivities || loading.addingProvider}
            >
              {loading.fetchingActivities && <span className="spinner"></span>}
              Search
            </button>
          </div>
          {loading.fetchingActivities && (
            <div className="mt-2">
              <span className="spinner"></span>
              Searching for taxpayer activities...
            </div>
          )}
        </div>

        {taxpayerActivities.length > 0 && (
          <div className="form-group">
            <label htmlFor="activity">Select Activity:</label>
            <select
              id="activity"
              value={selectedActivity}
              onChange={handleActivitySelect}
              disabled={loading.addingProvider}
            >
              <option value="">-- Select an activity --</option>
              {taxpayerActivities.map((activity) => (
                <option key={activity.activity} value={activity.activity}>
                  {activity.description} ({activity.activity})
                </option>
              ))}
            </select>
          </div>
        )}

        {taxpayerSearch && taxpayerActivities.length === 0 && !loading.fetchingActivities && (
          <div className="alert alert-info">
            No activities found for tax number: {taxpayerSearch}
          </div>
        )}

        <div className="d-flex gap-2 mt-3">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={
              !taxpayerSearch ||
              !selectedActivity ||
              loading.addingProvider ||
              loading.fetchingActivities
            }
          >
            {loading.addingProvider && <span className="spinner"></span>}
            Add New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleReset}
            disabled={loading.addingProvider}
          >
            Reset
          </button>

          <button
            type="button"
            className="btn btn-cancel"
            onClick={handleCancel}
            disabled={loading.addingProvider}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddServiceProvider;
